// extracted by mini-css-extract-plugin
export default {"button":"Button_button__Y+F0s","disabled":"Button_disabled__hk3n+","success":"Button_success__Oomt1","loading":"Button_loading__COAoG","spin":"Button_spin__PfRz2"};